// extracted by mini-css-extract-plugin
export default {"content":"style_content__5l9ff","buttons":"style_buttons__Iwe4p","bg_main":"style_bg_main__8Ql2Y","bg_top":"style_bg_top__Z6pRd"};